/** A measured figure rendered so it can be scanned down a column. */

import { cn } from "~/lib/utils";
import { EVAL_SCORE_MAX } from "~/services/evals";

/** A 1-4 judge score, or an em dash where the run recorded none. */
export const ScoreValue = ({ score, className }: { score: number | null; className?: string }) => {
  if (score == null) {
    return <span className={cn("text-muted-foreground", className)}>—</span>;
  }
  // Thirds of the 1-4 judge scale, per the suites' judging instructions.
  const tone = score >= 3.5 ? "text-green-700" : score >= 2.5 ? "text-orange-700" : "text-red-700";
  return (
    <span className={cn("tabular-nums", tone, className)}>
      {score.toFixed(2)}
      <span className="text-muted-foreground"> / {EVAL_SCORE_MAX}</span>
    </span>
  );
};
